<template>
  <b-container fluid>
    <div class="page-header">
      <div class="col-md-3">
        <b-row>
          <b-col md="auto">
            <h3>
              {{ name }}
              <small>(#{{ id }})</small>
            </h3>
          </b-col>
        </b-row>
      </div>
    </div>
    <hr>

    <div class="mb-3">
      <ErrorsContainer :errors="errors" />
    </div>
    <b-alert variant="success"
             dismissible
             fade
             :show="showSuccessfulUpdateMessage"
             @dismissed="showSuccessfulUpdateMessage=false">
      Affiliated Group was successfully updated.
    </b-alert>

    <ContingentForm :formObject="contingentForm" :showRemains="showContingentRemains" />
    <b-col md="auto" class="mt-4 pt-2">
      <button class="btn btn-success" v-promise-btn @click="updateContingent">Update contingent</button>
    </b-col>
    <hr>

    <AuditsContainer collapseBtnLabel="Contingent audits"
                     :auditableId="parseInt(contingentForm.id)"/>
    <hr>
    <b-row>
      <b-col md="6">
        <h4>Vendors</h4>
      </b-col>

      <b-col md="6">
        <h4>Products</h4>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <b-table outlined
                 hover
                 :items="vendors"
                 :fields="vendorFields"
                 id="vendorsTable"
                 thead-class="hidden">
        </b-table>
      </b-col>

      <b-col md="6">
        <b-table outlined hover :items="products" :fields="productFields" thead-class="hidden">
        </b-table>
      </b-col>
    </b-row>
    <hr>
  </b-container>
</template>

<script>
import AffiliatedGroupsProvider from '@/services/AffiliatedGroupsProvider'
import ContingentForm from '@/components/ContingentForm'
import ContingentsProvider from '@/services/ContingentsProvider'
import ErrorsContainer from '@/components/ErrorsContainer'
import AuditsContainer from '@/components/AuditsContainer'

export default {
  name: 'AffiliatedGroupDetails',
  components: {
    ContingentForm,
    ErrorsContainer,
    AuditsContainer
  },
  data () {
    return {
      id: this.$route.params.id,
      name: '',
      products: [],
      vendors: [],
      contingentForm: {},
      showContingentRemains: true,
      vendorFields: ['id', 'company_name'],
      productFields: ['name'],
      errors: [],
      showSuccessfulUpdateMessage: false
    }
  },
  mounted () {
    AffiliatedGroupsProvider.findById(this.$route.params.id).then(resp => {
      this.contingentForm = this.buildContingentForm(
        resp.body.affiliated_group.contingent
      )
      this.name = resp.body.affiliated_group.name
      this.products = resp.body.affiliated_group.products
      this.vendors = resp.body.affiliated_group.vendors
    })
  },
  methods: {
    updateContingent () {
      this.errors = []
      return new Promise((resolve, reject) => {
        ContingentsProvider.update(this.contingentForm.id, this.contingentForm).then(resp => {
          this.resetRemainDiffs()
          this.showSuccessfulUpdateMessage = true
          setTimeout(() => {
            this.showSuccessfulUpdateMessage = false
          }, 2000)
          resolve(resp)
        }, (resp) => {
          this.errors = resp.body.errors.base
          resolve(resp)
        })
      })
    },
    resetRemainDiffs () {
      this.contingentForm.dailyRemainDiff = null
      this.contingentForm.weeklyRemainDiff = null
      this.contingentForm.monthlyRemainDiff = null
      this.contingentForm.uniqueRemainDiff = null
    },
    buildContingentForm (contingent) {
      return {
        id: contingent.id,
        daily: contingent.daily,
        weekly: contingent.weekly,
        monthly: contingent.monthly,
        dailyRemain: contingent.daily_remain,
        dailyRemainDiff: null,
        weeklyRemain: contingent.weekly_remain,
        weeklyRemainDiff: null,
        monthlyRemain: contingent.monthly_remain,
        monthlyRemainDiff: null,
        uniqueRemain: contingent.unique_remain,
        uniqueRemainDiff: null
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
